<template>
  <table
    class="table b-table b-table-stacked-xs table-bordered table-sm bg-white text-uppercase"
  >
    <tbody>
      <tr>
        <th colspan="4">
          <h5 class="text-center"><b>CONDIÇÕES EDUCACIONAIS</b></h5>
        </th>
      </tr>
      <tr>
        <td colspan="4">
          <div v-for="usuario in item.familiares" :key="usuario.id">
            <div
              class="p-0 col-12 mb-3"
              v-if="usuario.escolaridade && usuario.escolaridade.length"
            >
              <table class="table table-bordered">
                <tbody>
                  <tr class="col-12">
                    <td colspan="2">
                      <strong>
                        {{ usuario.nome_completo }}
                      </strong>
                      <br />
                      Idade: {{ usuario.idade }} ano(s)<br />
                    </td>
                  </tr>
                  <tr>
                    <th>Sabe ler e escrever?</th>
                    <td>
                      {{
                        usuario.escolaridade[0].sabe_ler != null
                          ? usuario.escolaridade[0].sabe_ler == 1
                            ? "Sim"
                            : "Não"
                          : ""
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th>Frequenta escola atualmente?</th>
                    <td>
                      {{ findFrequentaEscola(usuario.escolaridade[0].frequenta_escola) }}
                    </td>
                  </tr>
                  <tr>
                    <th>Escolaridade</th>
                    <td>
                      {{
                        usuario.escolaridade[0].frequenta_escola == "1" ||
                        usuario.escolaridade[0].frequenta_escola == "2"
                          ? findFrequenta(usuario.escolaridade[0].curso_frequenta)
                          : findFrequentou(usuario.escolaridade[0].curso_frequentou)
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="p-0 col-12 mb-3" v-else>
              <table class="table table-bordered">
                <tbody>
                  <tr class="col-12">
                    <td colspan="2">
                      <strong>
                        {{ usuario.nome_completo }}
                      </strong>

                      <br />
                      Idade: {{ usuario.idade }} ano(s)<br />
                      <p class="text-small text-muted">
                        <b-icon
                          icon="exclamation-triangle-fill"
                          variant="warning"
                        ></b-icon>
                        Nenhuma informação de <b>Escolaridade</b> foi encontrada deste
                        usuário.
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: ["item"],
  methods: {
    findFrequentaEscola(frequenta_escola) {
      const frequenta = this.$root.arrays.frequenta_escola.find(
        (element) => element.id == frequenta_escola
      );

      return frequenta ? frequenta.value : "";
    },
    findFrequentou(curso_frequentou) {
      const frequentou = this.$root.arrays.curso_frequentou.find(
        (element) => element.id == curso_frequentou
      );
      return frequentou ? frequentou.value : "";
    },
    findFrequenta(curso_frequenta) {
      const frequenta = this.$root.arrays.curso_frequenta.find(
        (element) => element.id == curso_frequenta
      );
      return frequenta ? frequenta.value : "";
    },
  },
};
</script>

<style lang="scss" scoped></style>
